import { render, staticRenderFns } from "./SidebarLogo.vue?vue&type=template&id=30020e61&scoped=true&"
import script from "./SidebarLogo.vue?vue&type=script&lang=js&"
export * from "./SidebarLogo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLogo.vue?vue&type=style&index=0&id=30020e61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30020e61",
  null
  
)

export default component.exports